import { AxiosResponse } from 'axios';
import { CallHistoryMethodAction, goBack } from 'connected-react-router';
import {
  all,
  call,
  CallEffect,
  fork,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { getLocaleMsg } from '../../lngProvider';

// deleteDraft
const deleteDraftApi = async (letterCode: string, folderCode: string) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`Letter/DeleteLetter`, {
    letterCode: letterCode,
    folderCode: folderCode,
  });
};

function* deleteDraftRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  CallHistoryMethodAction<[]> | void,
  AxiosResponse<any>
> {
  const messages = getLocaleMsg();
  try {
    yield call(
      deleteDraftApi,
      action.payload.letterCode,
      action.payload.folderCode,
    );
    // yield put(onDeleteDraftSuccess());
    ShowSuccess(messages['messages.operationWasSuccessful'], '');
    return goBack();
  } catch (error) {
    return ShowError('', error);
  }
}

export function* deleteDraft() {
  yield takeEvery(ActionTypes.DELETE_DRAFT, deleteDraftRequest);
}

export default function* rootSaga() {
  yield all([fork(deleteDraft)]);
}
